import { Unmasks } from '@lsq-frontend/common-ui';

// TODO: Clean this up once inputs are rebuilt.
export function formatBpsInput(value: any): any {
    if (value === null || typeof value === 'undefined') {
        return value;
    }
    let formattedValue = value.toString().replace(Unmasks.CurrencyUnmask, '');

    if (value !== null && value !== '' && !isNaN(formattedValue)) {
        formattedValue = (+formattedValue).toFixed(2);
    }
    return formattedValue;
}
export function formatHbpsInput(value: any): any {
    if (value === null || typeof value === 'undefined') {
        return value;
    }
    let formattedValue = value.toString().replace(Unmasks.CurrencyUnmask, '');

    if (value !== null && value !== '' && !isNaN(formattedValue)) {
        formattedValue = (+formattedValue).toFixed(4);
    }
    return formattedValue;
}

export function handleBpsInput(event: KeyboardEvent): void {
    const pattern = /^-?[0-9\.-]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
        event.preventDefault();
    }
}

export function handleFboAccountType(value: any): any {
    if (value === null || typeof value === 'undefined') {
        return value;
    }

    switch (value) {
        case 'Bank_Of_America':
            return 'Bank of America';
        case 'US_Bank':
            return 'U.S. Bank';
        case 'Regions_Bank':
            return 'Regions Bank';
        case 'JP_Morgan':
            return 'J.P. Morgan';
        case 'Citizens':
            return 'Citizens';
        default:
            return value;
    }
}
